import { AvailableLang } from './models/translations';

export const IS_DISCORD_ACTIVITY = window.location.hostname.endsWith('discordsays.com');
export const IS_REDDIT = window.location.hostname.endsWith('devvit.net');
export const CDN_HOST = IS_DISCORD_ACTIVITY ? '/.proxy/cdn/' : 'https://d2gx7utkb1zhe1.cloudfront.net/';

export const HOST_PLATFORM = IS_DISCORD_ACTIVITY ? 'discord' : IS_REDDIT ? 'reddit' : 'web';

export const BP_MOBILE_CHAT = 992; // Also referenced in globals.scss

export const FAILURE_TIMEOUT_SECONDS = 5;
export const LS_HASSEENWORLDINTRO_KEY = 'ARISE_HASSEENWORLDINTRO';
export const LS_HASSEENSHOP_KEY = 'ARISE_HASSEENSHOP';
export const LS_NEWSMODAL_LAST_VERSION_SEEN_KEY = 'ARISE_NEWSMODAL_LAST_VERSION_SEEN';
export const FEED_MESSAGES_TO_LOAD = 20;

export const DEFAULT_LANG: AvailableLang = {
    langISO: 'en-us',
    displayName: 'en-us',
};
